import React, { Fragment, useEffect, useState } from 'react';
import { Button, Col, Container, Input, Row, Table } from 'reactstrap';
import { toast } from "react-toastify";
import _ from 'lodash';
import { FilterSelect, ServiceThreadSpinner } from '.';
import { api, filterHelpers } from '../utils';
import { confirmAlert } from "react-confirm-alert";

export default function ManageSalespersons() {
   const ALL_OPTS = { value: "", label: "-- Select --" };
   const INT_OPTS = { value: 0, label: "-- Select --" };
   const PRSN_MODEL = { id: "", name: "" };
   const USER_MODEL = { pkId: 0, userId: 0, salespersonId: "" };
   const XREF_MODEL = { id: "", name: "", pkId: 0, userId: 0 };
   const [crossRef, setCrossRef] = useState(XREF_MODEL);
   const [newRef, setNewRef] = useState(USER_MODEL);
   const [person, setPerson] = useState(PRSN_MODEL);
   const [personList, setPersonList] = useState([]);
   const [salesId, setSalesId] = useState("");
   const [userList, setUserList] = useState([]);
   const [xrefList, setXrefList] = useState([]);
   const [filters, setFilters] = useState([
      { filterName: "person", value: ALL_OPTS },
      { filterName: "user", value: ALL_OPTS },
      { filterName: "xref", value: ALL_OPTS }
   ]);
   const [spinSlprsn, setSpinSlprsn] = useState(true);

   useEffect(() => {
      runQuery();
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [])

   function onAddUser() {
      if (!newRef || newRef.userId === 0) {
         toast.error("Please provide a user to add to the cross-reference");
         return;
      }
      if (!salesId || salesId === "") {
         toast.error("Salesperson ID must be at least 3 characters");
         return;
      }

      setSpinSlprsn(true);
      api.post(`Reference/SaveSalespersonCrossRef/${newRef.userId}/${salesId}`)
         .then((response) => {
            if (response.data.success) {
               toast.success("User cross-reference created!")
               runQuery();
            } else {
               toast.error(response.data.message);
               setSpinSlprsn(false);
            }
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
            setSpinSlprsn(false);
         });
   }

   function onPersonChange(newFilterValue) {
      let newFilters = filterHelpers.getFilters(filters, newFilterValue);
      setFilters(newFilters);

      if (newFilterValue.value === "") {
         setPerson(PRSN_MODEL);
      }
      else { // Get the selected salesperson
         let changes = Object.assign({}, person);
         changes.id = newFilterValue.value;
         changes.name = newFilterValue.label;
         setPerson(changes);
      }
   }

   function onUserChange(newFilterValue) {
      let newFilters = filterHelpers.getFilters(filters, newFilterValue);
      setFilters(newFilters);

      setSalesId("");
      if (newFilterValue.value === 0) {
         setNewRef(USER_MODEL);
      }
      else { // Get the selected user
         let changes = Object.assign({}, newRef);
         changes.userId = newFilterValue.value;
         setNewRef(changes);
      }
   }

   function onXrefDelete() {
      setSpinSlprsn(true);
      api.post(`Reference/DeleteSalespersonCrossRef/${crossRef.pkId}`)
         .then((response) => {
            if (response.data.success) {
               toast.success("User cross-reference successfully deleted.")
               runQuery();
            } else {
               toast.error(response.data.message);
               setSpinSlprsn(false);
            }
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
            setSpinSlprsn(false);
         });
   }

   function onXrefChange(newFilterValue) {
      let newFilters = filterHelpers.getFilters(filters, newFilterValue);
      setFilters(newFilters);

      if (newFilterValue.value === "") {
         setCrossRef(XREF_MODEL);
      }
      else { // Get the selected user cross reference
         const itm = _.find(xrefList, (x) => x.value === newFilterValue.value);
         let changes = Object.assign({}, crossRef);
         changes.id = newFilterValue.value;
         changes.name = newFilterValue.label;
         changes.pkId = itm.pkId;
         changes.userId = itm.userId;
         setCrossRef(changes);
      }
   }

   function removePerson() {
      setSpinSlprsn(true);
      api.post(`Reference/HideSalespersonFromLists/${person.id}`)
         .then((response) => {
            if (response.data.success) {
               toast.success("Salesperson successfully removed.")
               runQuery();
            } else {
               toast.error(response.data.message);
               setSpinSlprsn(false);
            }
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
            setSpinSlprsn(false);
         });
   }

   function runQuery() {
      setSpinSlprsn(true);
      api
         .fetch(`Reference/GetSalespersonLists`)
         .then((response) => {
            if (response.data.success) {
               const spList = _.concat([ALL_OPTS],
                  _.map(response.data.salespeople, (sp) => ({
                     value: sp.salespersonId,
                     label: sp.salespersonText
                  })));
               const xList = _.concat([ALL_OPTS],
                  _.map(response.data.crossRef, (x) => ({
                     value: x.salespersonId,
                     label: x.salespersonText,
                     pkId: x.pkId,
                     userId: x.userId
                  })));
               const uList = _.concat([INT_OPTS],
                  _.map(response.data.noXref, (u) => ({
                     value: u.userId,
                     label: `${u.firstName} ${u.lastName}`
                  })));
               return { spList: spList, xList: xList, uList: uList };
            } else {
               toast.error(response.data.message);
            }
         })
         .then(({ spList, xList, uList }) => {
            setPersonList(spList);
            setXrefList(xList);
            setUserList(uList);
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
         })
         .finally(() => {
            setSalesId("");
            setPerson(PRSN_MODEL);
            setCrossRef(XREF_MODEL);
            setNewRef(USER_MODEL);
            setSpinSlprsn(false);
         });
   }

   const showDeleteXrefModal = () => {
      if (!crossRef || crossRef.id === "") {
         toast.error("Please select a valid user cross reference");
         return;
      }
      confirmAlert({
         title: "Confirm Delete",
         message: `Are you sure you want to delete ${crossRef.name} from the cross reference table?`,
         buttons: [
            { label: "Yes", onClick: () => { onXrefDelete() } },
            { label: "No" }
         ]
      });
   }

   const showRemoveModal = () => {
      if (!person || person.id === "") {
         toast.error("Please select a valid salesperson");
         return;
      }
      confirmAlert({
         title: "Confirm Removal",
         message: `Are you sure you want to remove ${person.name} from salesperson drop-down lists?`,
         buttons: [
            { label: "Yes", onClick: () => { removePerson() } },
            { label: "No" }
         ]
      });
   }

   return (
      <Container fluid>
         <Row>
            <Col>
               <Fragment>
                  <ServiceThreadSpinner on={spinSlprsn}>
                     <Row className="px-2 py-2">
                        <Col xxl={{ offset: 0, size: 12 }}>
                           {personList && personList.length ? (
                              <Table className="transparent-background my-0">
                                 <tbody>
                                    <tr>
                                       <td colSpan={3} className="transparent-background data-cell noWrap h6">
                                          Manage Salesperson Drop-Down Lists
                                       </td>
                                    </tr>
                                    <tr>
                                       <td className="transparent-background data-cell noWrap h6 width115px">
                                          Salesperson:
                                       </td>
                                       <td className="transparent-background width500px">
                                          <FilterSelect
                                             filterName="person"
                                             options={personList}
                                             value={filterHelpers.getValue(filters, "person")}
                                             onChangeCallback={e => onPersonChange(e)}
                                          />
                                       </td>
                                       <td className="transparent-background data-cell">
                                          <Button title="Remove" className="shredButton" onClick={() => showRemoveModal()} >
                                             Remove from Drop-Down Lists
                                          </Button>
                                       </td>
                                    </tr>
                                 </tbody>
                              </Table>
                           ) : null}

                           {xrefList && xrefList.length ? (
                              <div>
                                 <br />
                                 <hr/>
                                 <Table className="transparent-background my-0">
                                    <tbody>
                                       <tr>
                                          <td colSpan={4} className="transparent-background data-cell noWrap h6">
                                             Manage Portal Salesperson Cross Reference Table
                                          </td>
                                       </tr>
                                       <tr>
                                          <td className="transparent-background data-cell noWrap h6 width115px">
                                             Salesperson:
                                          </td>
                                          <td className="transparent-background width500px">
                                             <FilterSelect
                                                filterName="xref"
                                                options={xrefList}
                                                value={filterHelpers.getValue(filters, "xref")}
                                                onChangeCallback={e => onXrefChange(e)}
                                             />
                                          </td>
                                          <td className="transparent-background data-cell">
                                             <Button title="Delete" className="shredButton" onClick={() => showDeleteXrefModal()} >
                                                Delete Cross-Reference
                                             </Button>
                                          </td>
                                          <td className="transparent-background data-cell"></td>
                                       </tr>
                                    </tbody>
                                 </Table>
                              </div>
                           ) : null}


                           {userList && userList.length ? (
                              <div>
                                 <br />
                                 <hr />
                                 <Table className="transparent-background my-0">
                                    <tbody>
                                       <tr>
                                          <td colSpan={4} className="transparent-background data-cell noWrap h6">
                                             Add New User-to-Salesperson Cross Reference Table
                                          </td>
                                       </tr>
                                       <tr>
                                          <td className="transparent-background data-cell noWrap h6 width115px">
                                             User:
                                          </td>
                                          <td className="transparent-background width265px">
                                             <FilterSelect
                                                filterName="user"
                                                options={userList}
                                                value={filterHelpers.getValue(filters, "user")}
                                                onChangeCallback={e => onUserChange(e)}
                                             />
                                          </td>
                                          <td colSpan={2} className="transparent-background data-cell"></td>
                                       </tr>
                                       <tr>
                                          <td className="transparent-background data-cell noWrap h6 width115px">
                                             SLPRSNID:
                                          </td>
                                          <td className="transparent-background width265px">
                                             <Input
                                                type="text"
                                                value={salesId || ""}
                                                onChange={(e) => setSalesId(e.target.value)}
                                                maxLength="15"
                                             />
                                          </td>
                                          <td className="transparent-background data-cell">
                                             <Button title="Add" className="shredButton" onClick={() => onAddUser()} >
                                                Add Cross-Reference
                                             </Button>
                                          </td>
                                          <td className="transparent-background data-cell"></td>
                                       </tr>
                                    </tbody>
                                 </Table>
                              </div>
                           ) : null}

                        </Col>
                     </Row>
                  </ServiceThreadSpinner>
               </Fragment>
            </Col>
         </Row>
      </Container >
   );
}
